<template>
  <div id="sugestoes">
    <div class="w3-bar w3-top w3-light-gray w3-large w3-border" style="z-index:4">
      <router-link 
        to="/"
        class="w3-bar-item w3-button w3-hover-none w3-hover-text-theme">
        <i class="fa fa-chevron-left"></i>&nbsp;
        Voltar ao sistema
      </router-link>
      
      <router-link to="/" class="w3-bar-item w3-right">
        <img 
          style="width:20px" 
          src="/static/imagens/logos/logo_santri.png" 
          alt="Santri">
      </router-link>
    </div>
    
    <div class="w3-container" style="margin-top:50px;">
      <header>
        <div class="w3-panel w3-theme w3-center" v-cloak>
          <p>
            <b>Informe sugestões, críticas ou elogios a respeito da(s) empresa(s) : </b>
            <b v-for="(empresa, key) in empresas" :key="key">
              <span v-if="key>0">,</span> 
              {{empresa.empresa_id}} - {{empresa.nome_fantasia}}
            </b>
          </p>
        </div>
      </header>
      
      <div class="w3-row-padding" v-cloak>
        <div class="w3-col s12 m4">
          <label>Tipo</label>
          <select class="w3-select w3-border" v-model="tipo_sugestao">
            <option value='S'>Sugestões</option>
            <option value='C'>Críticas</option>
            <option value='E'>Elogios</option>
          </select>
        </div>
        
        <div class="w3-col s12 m4">
          <label>Empresa</label>
          <select 
            class="w3-select w3-border" 
            v-model="empresa_id" 
            id="empresa">
            <option 
              :value="empresa.empresa_id" 
              v-for="empresa in empresas"
              :key="empresa.empresa_id">
              {{empresa.empresa_id}} - {{empresa.nome_fantasia}}
            </option>
          </select>
        </div>
        
        <div class="w3-col s12 m4">
          <label>Departamento</label><small> (Opcional)</small>
          <select class="w3-select w3-border" v-model="departamento_id" id="departamento">
            <option 
              :value="departamento.departamento_id"
              v-for="departamento in departamentos"
              :key="departamento.departamento_id">
              {{departamento.departamento_id}} - {{departamento.nome}}
            </option>
          </select>
        </div>
        
        <div class="w3-col s12 m12">
          <label>Texto</label>
          <textarea
            class="w3-input w3-border" 
            cols="30"
            rows="5"
            id="texto"
            maxlength="4000"
          />
        </div>
        
        <div class="w3-col s12 m12">
          <label>Identificação</label>
          <small> (Opcional)</small>
          <input 
            type="text" 
            class="w3-input w3-border"
            maxlength="4000" 
            id="indentificacao"
            v-model="usuario_sugestao"
          />
        </div>

        <div class="w3-col s12 m12 w3-panel w3-theme w3-card-2" v-if="processando">
          <p><i class="fa fa-sync-alt w3-spin"></i> Processando...</p>
        </div>

        <div class="w3-col s12 m12">
          <br>
          <button
            class="w3-button w3-theme w3-block" 
            v-on:click="enviarSugestao()" 
            :disabled="processando">
            <i class="fa fa-paper-plane"></i>
            Enviar
          </button>
        </div>
      </div>
      <br>
    </div>
  </div><!-- sugestoes -->
</template>

<script>
  import RSugestao from '@/components/Rest/RSugestao.js'
  import REmpresa from '@/components/Rest/REmpresa.js'
  import RDepartamento from '@/components/Rest/RDepartamento.js'
  import Biblioteca from '@/components/Repositorio/Biblioteca.js'
 
  export default {
    name: 'Sugestoes',
    data() {
      return {
        api: process.env.API,
        processando: false,
        empresas: [],
        departamentos: [],
        empresa_id: '',
        departamento_id: '',
        tipo_sugestao: 'S',
        usuario_sugestao: '',
        sugestao_id: '0',
        status_sugestao: 'ABE'
      }
    },
    methods: {
      recarregarComponente(){
        document.getElementById('texto').value = "";
        Object.assign(this.$data, this.$options.data.call(this));
      },
      
      async buscarEmpresas(){
        try {
          this.processando = true;

          let retorno = await REmpresa.buscarEmpresasSugestao(this.axios);

          this.empresas = retorno.dados;
          this.processando = false;
        } catch (e) {
          this.processando = false;
          Biblioteca.exclamar(e.message);
        }
      },
      
      async buscarDepartamentos(){
        try {
          this.processando = true;

          let retorno = await RDepartamento.buscarDepartamentosSugestao(this.axios);
          
          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }

          this.departamentos = retorno.dados;
          this.processando = false;
        } catch (e) {
          this.processando = false;
          Biblioteca.exclamar(e.message);
        }
      },
      
      async enviarSugestao(){
        try {
          let texto = document.getElementById('texto').value;

          if (this.empresa_id == ''){
            Biblioteca.exclamar('Empresa não informada!');
            return;
          }

          if (this.departamento_id == ''){
            Biblioteca.exclamar('Departamento não informado!');
            return;
          }

          if (texto.trim() == ''){
            Biblioteca.exclamar('É necessário informar o texto!');
            return;
          }

          this.processando = true;

          let parametros = { 
            sugestao_id: this.sugestao_id,
            tipo: this.tipo_sugestao,
            empresa_id: this.empresa_id,
            departamento_id: this.departamento_id,
            texto: texto,
            usuario_sugestao: this.usuario_sugestao,
            status: this.status_sugestao 
          }

          let retorno = await RSugestao.enviarSugestao(this.axios, parametros);
          
          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }

          this.processando = false;

          Biblioteca.informar('Sugestão enviada com sucesso!');
          this.recarregarComponente();
          this.buscarEmpresas();
          this.buscarDepartamentos();
        } catch (e) {
          this.processando = false;
          Biblioteca.exclamar(e.message);
        }
      }
    },

    created: function(){
      this.buscarEmpresas();
      this.buscarDepartamentos();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Sugestoes.vue